import { ContractorItem } from 'src/ducks/types'
import { formatParams } from 'src/helpers'
import { UpdateRequest } from '~api/types'
import axios from '../axios'
import { ApiController } from './types'

const base = '/contractors'

const apiController: ApiController = {
  getContractors: async ({ start, limit, institutional, searchParams }) => {
    const params = formatParams(searchParams)

    return await axios
      .get(`${base}?${params}`, {
        params: {
          start,
          limit,
          institutional,
        },
      })
      .then((response) => response.data)
  },

  createContractor: async (request: Partial<ContractorItem>) =>
    await axios.post(`${base}`, request).then((response) => response.data),

  updateContractor: async (id: string, request: UpdateRequest) =>
    await axios
      .patch(`${base}/${id}`, request)
      .then((response) => response.data),

  deleteContractor: async (id: string) =>
    await axios.delete(`${base}/${id}`).then((response) => response.data),

  activateContractor: async (id: string) =>
    await axios.post(`${base}/${id}/activate`).then((response) => response.data),

  deactivateContractor: async (id: string) =>
    await axios.post(`${base}/${id}/deactivate`).then((response) => response.data),

  getContractorById: async (id: string) =>
    await axios.get(`${base}/${id}`).then((response) => response.data),
  setContractorTerritory: async (payload: { contractorId: string, territoryId: string }) =>
    await axios.post(`/territories/${payload.territoryId}/contractors/${payload.contractorId}`).then((response) => response.data),
  deleteContractorTerritory: async (payload: { contractorId: string, territoryId: string }) =>
    await axios.delete(`/territories/${payload.territoryId}/contractors/${payload.contractorId}`).then((response) => response.data),
}

export default apiController
